import { AFFORDABLE_PROGRAMS } from '../../constants/affordableProgramNames';
import { DO_NOT_WISH_PROVIDE_OPTION } from '../../components/LeaseAffordableApplicantFormCommonSections/configuration';

/**
 * "Do not wish to provide" can't sit alongside real races: picking a race
 * after it drops it, and picking it after races keeps only it. Returns the
 * same array when nothing needs to change.
 */
export const applyDoNotWishToProvideRule = (selectedRaces) => {
  if (selectedRaces.length < 2) return selectedRaces;
  if (selectedRaces[0] === DO_NOT_WISH_PROVIDE_OPTION.value) {
    return selectedRaces.filter(
      (race) => race !== DO_NOT_WISH_PROVIDE_OPTION.value,
    );
  }
  if (
    selectedRaces[selectedRaces.length - 1] === DO_NOT_WISH_PROVIDE_OPTION.value
  ) {
    return [DO_NOT_WISH_PROVIDE_OPTION.value];
  }
  return selectedRaces;
};

export const getIsValidProgramAndStateCode = (pap = [], stateCode) => {
  const programNames = pap.map((pap) => pap?.masterAffordableProgram?.name);

  const hasHUDProgram = programNames.includes(AFFORDABLE_PROGRAMS.HUD);
  const hasRDProgram = programNames.includes(AFFORDABLE_PROGRAMS.RD);
  const hasPHProgram = programNames.includes(AFFORDABLE_PROGRAMS.PH);

  /**
   * Note: This is valid when I am logged into an LIHTC or HOME affordable or mixed property
   * in Alabama, DC, Georgia, Kentucky, Louisiana, Mississippi, Michigan, Minnesota, North Carolina, Ohio,
   * South Carolina, Wisconsin, Florida, Oregon or Texas
   */
  const isValidState = enableStatesCode.includes(stateCode);
  /**
   * Note: This is valid when I am logged into a property with HUD, RD or PH affordable or mixed
   * property. The PH 50058 reports multiRace in every state (ENG-31997), so PH sites must be able
   * to see and edit it.
   */
  const isValidFederalProgram = hasHUDProgram || hasRDProgram || hasPHProgram;

  return isValidFederalProgram || isValidState;
};

export const enableStatesCode = [
  'AL',
  'DC',
  'GA',
  'KY',
  'LA',
  'MS',
  'MI',
  'MN',
  'NC',
  'OH',
  'SC',
  'WI',
  'FL',
  'OR',
  'TX',
];
